import Cookies from 'js-cookie';
import g_Variable from '../global/GlobalVariables';

const $ = window.jQuery;

export default {
    /**
     * Store a new cookie
     * @param name
     * @param value
     * @param expires
     * @param path
     * @returns {*}
     */
    addCookie: function (name, value, expires = g_Variable.cookie_expires, path = g_Variable.cookie_path) {
        let msg = "";
        let cookieInfo = {
            expires: expires,
            path: path
        };

        // Name validity
        if (name != "" && name.length > 0 && typeof name != "undefined") {
            let cookie = Drupal.behaviors.jsCookie.getCookie(name);

            if (typeof cookie != 'undefined') {
                msg = "Cookie name already exists!";

                return msg;
            };
        }
        else {
            msg = "Cookie name is not defined!";

            return msg;
        }

        // Expires validity.
        if ($.isNumeric(expires) === false || expires <= 0) {
            msg = "Expiration data is unvalid!";

            return msg;
        }

        // Store cookie with all provided data.
        try {
            jsCookie.set(name, value, cookieInfo);
            return true;

        }
        catch (err){
            return "Something went wrong. Cookie was not set!";
        }
    },
    /**
     * Remove cookie
     * @param name
     */
    removeCookie: function (name) {
        try {
            jsCookie.remove(name);

            return true;
        }
        catch (err){
            return `Something went wrong ${err}. Cookie with name: ${name} can't be read!`;
        }
    },
    /**
     * Get stored cookie.
     * @param name
     * @returns {*}
     */
    getCookie: function (name) {
        try {
            return jsCookie.get(name);
        }
        catch (err){
            return `Something went wrong. Cookie with name: ${name} can't be read!`;
        }
    },
    /**
     * Get all stored cookie.
     * @returns {*}
     */
    getAllCookie:function () {
        try {
            return jsCookie.get();
        }
        catch (err){
            return `Something went wrong. Cookies can't be read!`;
        }
    }
};
